export default __webpack_public_path__ + "static/media/SJA1500.34I-42080_-25225_0.b23f79c5.jpg";